import { useState } from "react";
import * as Scrivito from "scrivito";

import json from "./icons.json";

export const LaIconEditorTab = Scrivito.connect(
  ({ widget, obj, attribute = "icon" }) => {
    const [query, setQuery] = useState("");

    const actualObj = widget || obj;
    const actualIcon = actualObj.get(attribute);

    const updateWidgetIcon = (event, icon) => {
      event.preventDefault();
      event.stopPropagation();

      actualObj.update({ [attribute]: icon });
    };

    return (
      <div className="la-icon-editor-tab">
        <div className="row">
          <div className="col-8">
            <input
              type="text"
              placeholder="Search for an icon..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="icon-search"
              autoFocus
            />
          </div>
          <div className="col-4">
            <div className="icon-item">
              <i className={actualIcon} />
            </div>
          </div>
        </div>
        <div className="icon-list">
          {json.map(
            (icon) =>
              icon.name.includes(query) && (
                <div
                  key={icon.name}
                  className={`icon-item ${
                    actualIcon === icon.className ? "--selected" : ""
                  }`}
                  onClick={(e) => updateWidgetIcon(e, icon.className)}
                >
                  <i className={icon.className} />
                  <span>{icon.name}</span>
                </div>
              )
          )}
        </div>
      </div>
    );
  }
);
